import { v4 as uuid } from 'uuid';
import { httpPOST } from './utils';
import { selectNextRequest } from '../root_reducer';
import {
    ADD_REQUEST,
    TRIED_REQUEST,
    COMPLETE_REQUEST,
} from '../reducers/request_queue';

const handlers = {};

export const registerHandler = (name, callback) => {
    if (handlers[name] !== undefined) {
        throw new Error(`Duplicate handler: ${name}`);
    }

    handlers[name] = callback;
};

registerHandler('httpPOST', httpPOST);

const triedRequest = request => ({
    type: TRIED_REQUEST,
    payload: {
        id: request.id,
        timestamp: Date.now(),
    },
});

export const completeRequest = request => ({
    type: COMPLETE_REQUEST,
    payload: {
        id: request.id,
    },
});

let running = false;
export const processNext = () =>
    async function(dispatch, getState) {
        const next = new Promise(async (res, rej) => {
            if (running) {
                return next;
            }
            running = true;

            const request = selectNextRequest(getState());
            try {
                if (!request) {
                    return res();
                }
                const { handler, args } = request;

                await handlers[handler](...args);

                dispatch(completeRequest(request));
                res();
            } catch (e) {
                dispatch(triedRequest(request));
                return next;
            } finally {
                running = false;
            }
            dispatch(processNext());
            return next;
        });
        return next;
    };

export const queueRequest = (name, ...args) => {
    if (typeof handlers[name] !== 'function') {
        throw new Error(`Invalid handler: ${name}`);
    }

    return async dispatch => {
        const id = uuid();
        dispatch({
            type: ADD_REQUEST,
            payload: {
                args,
                handler: name,
                id,
            },
        });
        try {
            await dispatch(processNext());
        } catch (e) {
            throw new Error(id);
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/request_queue.js